import { Platform } from "react-native";
import styled from "styled-components/native";
import { dimenWidth } from "../../utils/helper";

export default styled.TouchableOpacity`
  align-items: center;
  margin-right: 0;
  width: ${Platform.OS === "web" ? "54" : dimenWidth(72)}px;
`;
